import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import sorento from "../../../../assets/info/sorento-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const KiaSorento = () => {
  useSmallNav("Kia Sorento");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Kia Sorento"} bolder />
        <InfoHero image={sorento} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Do you own and drive a Kia Sorento? Looking for suspension parts or suspension upgrades?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Then you have come to the right place."}
            />
            <p>
              Has your Sorento Self Levelling suspension failed? And you have
              just recieved the prices for replacements? If so, then you have
              just found the cost effective solution to your failed Sorento
              Suspension.
            </p>
            <p>
              This kit is used to replace the Original Self-Levelling
              Suspension.. This kit is a direct bolt in replacement. No
              modifications to the vehicle are required. No extra parts are
              required.
            </p>
            <p>
              "Will my vehicle really be returned to its original Ride height?"
              Yes, definitely! There are numerous examples of Sorentos having
              had the Self-Levellers replaced with conventional dampers which
              then sit too low. This is because the original spring is too weak
              to support the full weight of the car as it is normally assisted
              in this task by the self levelling damper.
            </p>
            <p>
              Pedders Suspension overcome this be supplying a matched set of
              dampers and springs specifically for this purpose. You can buy
              with full confidence that the vehicle will be the correct height
              and your troublesome and expensive self levelling dampers
              consigned to history.
            </p>
            <p>
              Please note that their are 2 version of Sorento rear suspension.
              Upto approx mid 2007 the top mount of the shock absorber was a
              "loop" style mount. Later models use a "pin" style mount. This kit
              is for the earlier "loop" style mounts. Please see the picture if
              you are unsure.
            </p>
            <p>
              Please note our vehicle height measurements are based on 16 inch
              wheels. This does not mean it will only fit cars with 16 inch
              wheels. The kit WILL fit irrespective of wheel size.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/9PvSqeTDVxk"
              title={"Kia Sorento Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Kia Sorento Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Kia")
              .models.find((e) => e.display === "Sorento")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        <InfoFooter make="Kia" model="Sorento" />
      </Container>
    </section>
  );
};

export default KiaSorento;
